import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/(lang)/(homepageGroup)/loading.jsx");
